<template>
  <div>
    <a-card class="page-header-card">
      <a-page-header title="埋点测试" sub-title="神策埋点测试工具">
        <span>环境: </span>
        <a-select v-model="env" style="width: 120px">
          <a-select-option value="test"> 测试环境 </a-select-option>
          <a-select-option value="product"> 生产环境 </a-select-option>
        </a-select>
        <a-upload name="fileName" :data="getUploadData" :show-upload-list="false" :headers="headers" :action="actionUrl" @change="handleChange">
          <a-button type="primary" icon="cloud-upload" class="page-header-card_button"> 上传文件 </a-button>
        </a-upload>
        <a-button type="primary" icon="cloud-download" @click="onDownload"> 下载模板 </a-button>
      </a-page-header>
    </a-card>
    <a-card title="埋点数据" size="small">
      <span v-if="currentEnv" slot="extra">
        当前环境: <a-tag :color="currentEnv === 'test' ? '#2db7f5' : '#87d068'"> {{ currentEnv === 'test' ? '测试环境' : '生产环境' }} </a-tag>
      </span>
      <div v-if="tableData.length === 0">
        <a-upload-dragger name="fileName" :multiple="false" :data="getUploadData" :show-upload-list="false" :headers="headers" :action="actionUrl" @change="handleChange">
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">单击或拖动埋点数据文件到此区域上传</p>
          <p class="ant-upload-hint">如果没有埋点数据文件，请先下载模板，填写埋点数据后再上传</p>
        </a-upload-dragger>
      </div>
      <div v-else>
        <a-table :scroll="{ x: 1200 }" :columns="columns" size="middle" :data-source="tableData" row-key="number">
          <span slot="action" slot-scope="text, record">
            <a :href="record.url" target="_blank">查看</a>
          </span>
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
import { getCookies } from '@/utils/utils';
export default {
  data() {
    return {
      loading: false,
      env: 'test',
      columns: [],
      tableData: [],
      uplaadLoading: false,
      uploadData: {},
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/tools/SensorsUpload`,
      headers: {
        Authorization: getCookies()
      },
      currentEnv: null
    };
  },
  methods: {
    getUploadData() {
      return {
        env: this.env
      };
    },

    onDownload() {
      window.open('https://devops-resource.oss-cn-shanghai.aliyuncs.com/documents/%E5%9F%8B%E7%82%B9%E6%B5%8B%E8%AF%95%E6%A8%A1%E6%9D%BF.xlsx');
    },

    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uplaadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.uplaadLoading = false;
        const { code, message, data } = info.file.response;
        if (code === 2000) {
          this.columns = [
            {
              title: '序号',
              align: 'center',
              width: 50,
              dataIndex: 'number',
              fixed: 'left'
            }
          ];
          data.titles.forEach(item => {
            this.columns.push({
              title: item,
              dataIndex: item,
              ellipsis: true,
              width: item === '查看方式' ? 200 : 110
            });
          });
          this.columns.push({
            title: '操作',
            width: 80,
            align: 'center',
            scopedSlots: { customRender: 'action' },
            fixed: 'right'
          });
          this.tableData = data.values.map((item, index) => {
            return { number: index + 1, ...item };
          });
          this.currentEnv = data.env;
        } else {
          this.$message.warning(message);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.page-header-card {
  margin-bottom: 16px;
  .ant-card-body {
    padding: 0;
  }
  .page-header-card_button {
    margin: 0 16px;
  }
}
</style>
